import restrictions from '../config/dashboardTabRestrictions.json';

const VIEW_KEYS = ['orders', 'inventory', 'deliveries', 'campaigns', 'reviews'];

/** @type {Record<string, boolean>} */

const PLAN_NUMBER = {
  0: {
    orders: false,
    inventory: false,
    deliveries: false,
    campaigns: false,
    reviews: false,
  },
  1: {
    orders: true,
    inventory: false,
    deliveries: false,
    campaigns: false,
    reviews: true,
  },
  2: {
    orders: true,
    inventory: false,
    deliveries: false,
    campaigns: false,
    reviews: true,
  },
  5: {
    orders: true,
    inventory: false,
    deliveries: true,
    campaigns: true,
    reviews: true,
  },
  8: {
    orders: true,
    inventory: false,
    deliveries: true,
    campaigns: true,
    reviews: true,
  },
};

/** @param {{ emails?: string[] } | null | undefined} block @param {{ email?: string } | null | undefined} user */
function userMatchesBlock(block, user) {
  if (!user || !block) return false;
  const { emails = [] } = block;
  const email = user.email?.trim().toLowerCase();
  if (email && emails.some((e) => String(e).trim().toLowerCase() === email)) {
    return true;
  }
  return false;
}

/** @param {Record<string, unknown>} raw */
function normalizeVisibility(raw) {
  /** @type {Record<string, boolean>} */
  const out = {};
  for (const k of VIEW_KEYS) {
    if (k === 'reviews') {
      // Match sidebar / dashboard: reviews is shown unless explicitly false
      out.reviews = raw.reviews !== false;
    } else {
      out[k] = !!raw[k];
    }
  }
  return out;
}

/**
 * @typedef {{ plan_number?: number | null, payment_status?: boolean | null }} StoreBilling
 */

/**
 * Which main dashboard tabs are visible for this user (and optional store billing context).
 * @param {{ email?: string } | null | undefined} user
 * @param {StoreBilling | null | undefined} storeBilling — `plan_number` & `payment_status` from `public.stores` for the active store
 * @returns {Record<'orders' | 'inventory' | 'deliveries' | 'campaigns' | 'reviews', boolean>}
 */
export function getDashboardTabVisibility(user, {
  plan_number,
  payment_status,
}) {
  if (payment_status === false) {
    return {
      orders: false,
      inventory: false,
      deliveries: false,
      campaigns: false,
      reviews: false,
    }
  }
  const overrides = restrictions?.overrides ?? [];
  for (const block of overrides) {
    if (userMatchesBlock(block, user)) {
      return normalizeVisibility(block.tabs ?? {});
    }
  }

  const PLAN = PLAN_NUMBER[plan_number] || {};
  const visibility = { ...PLAN };
  return visibility;
}
